import { useEffect, useState } from 'react';

// glove mode + hand side. hand 'l' = Linkshand-Modus (tools right), 'r' = Rechtshand-Modus (tools left)
const K = 'giss_glove';
const DEF = { on: false, hand: 'l' };
const get = () => { try { return { ...DEF, ...JSON.parse(localStorage.getItem(K) || '{}') }; } catch { return DEF; } };

function apply(v) {
  const h = document.documentElement;
  h.classList.toggle('glove', !!v.on);
  h.classList.toggle('tools-left', v.hand === 'r');
}

export function setGlove(p) {
  const v = { ...get(), ...p };
  localStorage.setItem(K, JSON.stringify(v));
  apply(v);
  window.dispatchEvent(new Event('giss-glove'));
}

export const toolsLeft = (g) => g.hand === 'r';
export const flipHand = () => setGlove({ hand: get().hand === 'l' ? 'r' : 'l' });

export function useGlove() {
  const [v, setV] = useState(get);
  useEffect(() => { const on = () => setV(get()); window.addEventListener('giss-glove', on); return () => window.removeEventListener('giss-glove', on); }, []);
  return v;
}

export const buzz = (p = 40) => { if (get().on) navigator.vibrate?.(p); };

apply(get());
